import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import EstimationService from "../../services/EstimationService"

export const getAllEstimations = createAsyncThunk(
  "estimations/getAll",
  async (
    { page = 1, cardId, kilometrageMin, kilometrageMax },
    { rejectWithValue }
  ) => {
    try {
      const response = await EstimationService.getAll(
        page,
        cardId,
        kilometrageMin,
        kilometrageMax
      )
      return response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Erreur lors du chargement"
      )
    }
  }
)

export const getEstimationById = createAsyncThunk(
  "estimations/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EstimationService.getById(id)
      return response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Erreur lors du chargement"
      )
    }
  }
)

export const addResponse = createAsyncThunk(
  "estimations/addResponse",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await EstimationService.addResponse(id, data)
      return response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Erreur lors du chargement"
      )
    }
  }
)

// 🔹 Initial state
const initialState = {
  estimations: [],
  estimation: null,
  loading: false,
  error: null,
  totalItems: 0,
}

const estimationSlice = createSlice({
  name: "estimations",
  initialState,
  reducers: {
    clearEstimation: (state) => {
      state.estimation = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    // -------- getAllEstimations --------
    builder
      .addCase(getAllEstimations.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getAllEstimations.fulfilled, (state, action) => {
        state.loading = false
        state.estimations = action.payload.data
        state.totalItems = action.payload.total
      })
      .addCase(getAllEstimations.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

    // -------- getEstimationById --------
    builder
      .addCase(getEstimationById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getEstimationById.fulfilled, (state, action) => {
        state.loading = false
        state.estimation = action.payload.data
      })
      .addCase(getEstimationById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
    // -------- add response --------
    builder
      .addCase(addResponse.pending, (state) => {
        state.error = null
      })
      .addCase(addResponse.fulfilled, (state, action) => {
        state.error = null
        state.estimation = action.payload.data
      })
      .addCase(addResponse.rejected, (state, action) => {
        state.error = action.payload
      })
  },
})

export const { clearEstimation } = estimationSlice.actions
export default estimationSlice.reducer
